import router from 'next/router';
import { useCallback } from 'react';
import { CURRENCY_CODES_BY_SYMBOL } from '@/core/constants';
import { ICheckoutPayLoad } from '@/core/infra';
import { checkoutPrice } from '@/core/requests/checkout/checkoutPrice/checkoutPrice';
import { cpSuccess } from '@/core/requests/checkout/cpSuccess';

export const useBuyFreeHandler = (
  checkoutParams: Omit<ICheckoutPayLoad, 'cancelUrl' | 'successUrl'>,
  promocode?: string
) => {
  const handleBuyFree = useCallback(async () => {
    try {
      const currencyCode = CURRENCY_CODES_BY_SYMBOL[checkoutParams.currency];
      const checkoutData = await checkoutPrice({
        cancelUrl: '/',
        successUrl: '/',
        ...checkoutParams,
        currency: currencyCode,
      });

      let sessionId;
      // submit cp
      if ('invoiceId' in checkoutData) {
        const data = checkoutData;
        await cpSuccess({
          price: 0,
          invoiceId: data.invoiceId,
          promocode: promocode,
          currency: currencyCode,
        });
        sessionId = data.publicId;
      }

      // submit stripe
      // todo: uncomment when stripe will be done
      // if ('sessionId' in checkoutData) {
      //   const data = checkoutData as IStripeCheckoutResonse;
      //   await stripeSuccess(data.sessionId);
      // }

      router.push(`/terminal/checkout/success?sessionId=${sessionId}`);
    } catch (e) {
      console.error(e);
    }
  }, [checkoutParams]);

  return handleBuyFree;
};
